
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/orders-sales",
      function () {
        return require("private-next-pages/my-account/orders-sales/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/orders-sales"])
      });
    }
  